import React from 'react';
import AppLayout from './pages/layout/AppLayout';
import './App.scss';

const App = () => {
  return <AppLayout/>
}

export default App;
